import { create } from 'zustand';
import { persist } from 'zustand/middleware';

/** Persisted view-mode preference for the API keys & bots list (CLAUDE.md §2.3). */
export type KeysViewMode = 'table' | 'cards';

interface KeysUiState {
  view: KeysViewMode;
  setView: (view: KeysViewMode) => void;
}

export const useKeysUi = create<KeysUiState>()(
  persist(
    (set) => ({
      view: 'table',
      setView: (view) => set({ view }),
    }),
    {
      name: 'dev13.keys.ui',
      // Only the durable view pref is persisted; filters/search stay session-local.
      partialize: (s) => ({ view: s.view }),
    },
  ),
);
